/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
:host {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  padding-bottom: var(--ux-steps-item-padding-bottom, 32px);
}
:host::before {
  background: linear-gradient(to right, #fff 0, #bbd03a 100%);
  content: "";
  height: 2px;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 25;
}
@media only screen and (width >= 768px) {
  :host::before {
    height: 3px;
  }
}

:host([generated]) {
  padding-bottom: 0;
}

.ux-steps__outer-line {
  height: 2px;
  width: 100%;
}
@media only screen and (width >= 768px) {
  .ux-steps__outer-line {
    height: 3px;
  }
}
.ux-steps__outer-line--right {
  background: linear-gradient(to right, #a6a6a6 0, #fff 100%);
}
.ux-steps__outer-line--left {
  background: linear-gradient(to right, #fff 0, #bbd03a 100%);
}
.ux-steps__indicators {
  display: flex;
}

ux-steps-item:last-of-type,
::slotted(ux-steps-item:last-of-type) {
  margin-right: 0;
}